<template>
  <div>
    <div
      class="header-nav"
      :class="
        navIndex !== '' || ifSearch || routeName != 'home'
          ? 'header-nav-active'
          : ''
      "
    >
      <div class="header-nav-logo" @click="toHome">
        <img :src="logo" />
      </div>
      <!-- <div class="search-box" @click="showSearch" v-show="!ifSearch">
        <i class="icon-search"></i>
      </div> -->
      <div class="header-nav-right-box">

      </div>
      <ul class="header-nav-wrapper" v-show="!ifSearch">
        <li
          v-for="(item, index) in navList"
          :key="index"
          @mouseenter="navEnter(index, item.name)"
          @mouseleave="navLeave(index, item.name)"
          @click="itemClick(item.name)"
        >
          <router-link :to="item.path" :class="{'active-path':curPath(item) }">{{ item.name }}</router-link>
          <dl v-if="item.children.length > 0 && index === navIndex">
            <dt v-for="(i, n) in item.children" :key="n">
              <router-link :to="i.path">{{ i.name }}</router-link>
            </dt>
          </dl>
        </li>
      </ul>
      <div ref="search-input-box" class="search-input-box" v-show="!searchIcon ? !ifSearch : ifSearch" v-if="!searchIcon || (searchIcon && ifSearch)">
        <i class="icon-search" @click="toSearch"></i>
        <input
          type="text"
          ref="input"
          @keyup.enter="toSearch"
          v-model.trim="keyword"
          placeholder="请输入产品名称"
        />
        <i class="icon-delete" @click="clearWord" v-show="keyword"></i>
        <ul ref="tishi-box" class="tishi-box" v-show="ifLX">
          <li
            @click="clickWord(item)"
            v-for="(item, index) in lxList"
            :key="index"
          >
            {{ item }}
          </li>
        </ul>
      </div>
      <div class="search-box" @click="showSearch" v-show="!ifSearch" v-if="searchIcon">
        <i class="icon-search"></i>
      </div>
    </div>
    <div
      class="search-open"
      v-show="ifSearch && routeName != 'search'"
      @click="hideSearch"
    ></div>
  </div>
</template>
<script>
import { suggester, categoryList } from '@/api/index'
import bus from '@/util/bus'
import { buryPoint } from '@/util/utils'
export default {
  data () {
    return {
      logo: require('@/assets/images/logo.png'),
      navIndex: '',
      navList: [
        {
          name: '首页',
          path: '/home',
          children: []
        },
        {
          name: '产品',
          path: '/productList',
          children: []
        },
        // {
        //   name: '招商加盟',
        //   path: '/join',
        //   children: []
        // },
        {
          name: '成为会员',
          path: '/member',
          children: []
        },
        {
          name: '招商加盟',
          path: '/merchantsJoin',
          children: []
        },
        {
          name: '关于特百惠',
          path: '/about/3',
          children: [
            // {
            //   name: '特百惠全球',
            //   path: '/about/3'
            // },
            // {
            //   name: '特百惠中国',
            //   path: '/about/7'
            // },
            // {
            //   name: '社会责任',
            //   path: '/about/9'
            // },
            // {
            //   name: '防伪查询',
            //   path: '/about/11'
            // },
            // {
            //   name: '举报假货',
            //   path: '/about/12'
            // }
          ]
        }
      ],
      keyword: '',
      ifSearch: false,
      ifLX: false,
      lxList: [],
      routeName: '',
      lxc: '',
      loading: false,
      windowWidth: window.innerWidth || 0,
      searchIcon:false,
    }
  },
  computed: {
    curPath(){
      return function (item) {
        if(this.$route.path.indexOf('productDetail') !== -1){
          return item.path == '/productList'
        }else {
          return this.$route.path.indexOf(item.path) !== -1
        }
      }
    }
  },
  watch: {
    keyword (val) {
      if (val.length > 1 && val !== this.lxc) {
        this._search()
      } else {
        this.lxc = ''
        this.lxList = []
      }
    },
    $route (val, oldVal) {
      this.routeName = val.name
      if (oldVal.name === 'search') {
        this.ifSearch = false
        this.keyword = ''
      }
      console.log(val)
    },
    windowWidth (val) {
      // if(this.$refs['search-input-box']) {
      //   console.log(val,this.$refs['search-input-box'].offsetWidth - 52,'val');
      //   this.$refs.input.style.width = `${this.$refs['search-input-box'].offsetWidth - 52}px`
      // }
      // if(this.$refs['tishi-box']) {
      //   this.$refs['tishi-box'].style.width = `${this.$refs['search-input-box'].offsetWidth}px`
      // }
      if(val > 1000) {
        this.searchIcon = false
      }else {
        this.searchIcon = true
      }
    }
  },
  methods: {
    toHome () {
      this.$router.push({
        path: '/'
      })
    },
    navEnter (index, name) {
      this.navIndex = index
      // this.menuName = name
    },
    navLeave (index, name) {
      this.navIndex = ''
      // this.menuName = name
    },
    showSearch () {
      buryPoint('Search_Button_Click')
      this.ifSearch = true
      this.keyword = ''
      this.lxList = []
      this.$refs.input.focus()
    },
    hideSearch () {
      this.ifSearch = false
    },
    clickWord (val) {

      this.keyword = val
      this.lxc = val
      this.ifLX = false
      this.toSearch()
    },
    toSearch () {
      if (!this.keyword || this.keyword.length < 2) {
        this.$Message.info({
          content: '关键词需至少两个字',
          duration: 2
        })
        return
      }
      this.ifLX = false
      buryPoint('Search_Submit',{search_keyword:this.keyword})
      if (this.routeName !== 'search') {
        this.$router.push({
          path: '/search',
          query: {
            keyword: this.keyword
          }
        })
      }
      // 通过事件总线通知更新
      bus.$emit('search', this.keyword)
    },
    clearWord () {

      this.keyword = ''
    },
    itemClick (name) {
      buryPoint('Menu_Click',{button_name:name})
    },
    _search () {
      if (this.loading) {
        return
      }
      this.loading = true
      suggester({
        condition: {
          keywords: this.keyword
        },
        pagingQuery: {
          pageIndex: 1,
          pageSize: 5
        }
      }).then(
        (res) => {
          this.lxList = res.models
          if (this.lxList.length) {
            this.ifLX = true
          }
          this.loading = false
        },
        () => {
          this.loading = false
        }
      )
    },
    _categoryList () {
      categoryList().then((res) => {
        window.sessionStorage.setItem(
          'categoryList',
          JSON.stringify(res.models)
        )
        // this.navList[1].children = res.models.map((item) => {
        //   return {
        //     name: item.name,
        //     path: `/productList?categoryId=${item.categoryId}`
        //   }
        // })
      })
    }
  },
  created () {
    this._categoryList()
  },
  mounted () {
    window.onresize = () => {
      this.windowWidth = window.innerWidth
    }
  }
}
</script>
<style lang="scss" scoped>
.header-nav {
  position: fixed;
  background: rgba(255, 255, 255, 0.75);
  box-shadow: 0px 0px 20px 0px rgba(117, 124, 131, 0.2);
  z-index: 10;
  width: 100%;
  height: 70px;
  line-height: 70px;
  padding: 0 50px;
  transition: background 0.1s linear 0s;
  min-width: 1000px;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  &.header-nav-active {
    background: #fff;
  }
  .header-nav-logo {
    img {
      width: 190px;
      vertical-align: middle;
      cursor: pointer;
    }
  }
  .header-nav-wrapper {
    display: flex;
    flex-wrap: nowrap;
    li {
      flex-shrink: 0;
      padding: 0 30px;
      font-size: 16px;
      cursor: pointer;
      position: relative;
      list-style-type: none;
      & > a {
        color: #000;
      }
      
      // &:hover {
      //   &:after {
      //     opacity: 1;
      //     transform: translate(-50%, 0) scaleX(1);
      //   }
      // }
    }

    .active-path {
      font-weight: 600;
      &:after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 43px;
        height: 3px;
        background: #000;
        border-radius: 2px;
        transform: translate(-50%, 0) scaleX(1);
        transition-duration: 500ms;
      }
    }

    dl {
      position: fixed;
      width: 100%;
      left: 0;
      background-color: #fff;
      z-index: 10;
      padding-right: 50px;
      transition: display 0.2s linear;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-end;
      dt {
        a {
          font-size: 14px;
          color: #666;
          padding-left: 60px;
          position: relative;
          &:hover {
            color: #000;
          }
        }
      }
    }
  }
  .search-box {
    width: 36px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    font-weight: bold;
    background: #fff;
    box-shadow: 0px 0px 19px 1px rgba(117, 124, 131, 0.2);
    border-radius: 50%;
    float: right;
    // margin-top: 17px;
    cursor: pointer;
  }
  .search-input-box {
    position: relative;
    // right: 50px;
    // top: 17px;
    flex: 1;
    max-width: 300px;
    height: 36px;
    line-height: 36px;
    background: #fff;
    box-shadow: 0px 0px 19px 1px rgba(117, 124, 131, 0.36);
    border-radius: 18px;
    display: flex;
    align-items: center;
    z-index: 20;
    .icon-search {
      margin-left: 8px;
      cursor: pointer;
    }
    input {
      border-radius: 18px;
      width: 10vw;
      flex: 1;
      text-indent: 10px;
    }
    .icon-delete {
      cursor: pointer;
      padding: 0 10px;
      justify-content: flex-end;
      display: flex;
    }
    .tishi-box {
      position: absolute;
      top: 44px;
      left: 0;
      width: 100%;
      background: #fff;
      box-shadow: 0px 0px 19px 1px rgba(117, 124, 131, 0.36);
      // transition: display 0.2s linear;
      display: flex;
      flex-direction: column;
      li {
        width: 100%;
        font-size: 12px;
        color: #000000;
        line-height: 30px;
        cursor: pointer;
        padding: 0 14px;
        list-style-type: none;
        &:hover {
          background-color: rgb(247, 247, 247);
        }
        &:first-child {
          margin-top: 5px;
        }
        &:last-child {
          margin-bottom: 5px;
        }
      }
    }
  }
}
.search-open {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 1;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 8;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue